module.exports = __webpack_public_path__ + "static/media/Map.55855508.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Map.png
// module id = 353
// module chunks = 0